import React from "react";
import "../landing.css";
import styled from "styled-components";
import logoPath from "@asset/ces/ces-logo.png";

const CesLogo = styled.img`
  max-width: 298px;
  height: 94px;
  margin: 0;

  @media screen and (max-width: 480px) {
    max-width: 200px;
    height: 60px;
  }
`;

const EventDetails = () => {
  return (
    <div className="landing-section-event">
      <h1 className="event-section-title">Event Details</h1>
      <div className="event-details-container">
        <div className="welcome-container">
          <p className="welcome-text welcome-text-1">Welcome to Visit</p>
          <p className="welcome-text welcome-text-2">
            MINDSAI Booth at
            <span className="welcome-text welcome-text-3">CES 2025</span>
          </p>
          <div className="ces-container">
            <CesLogo src={logoPath} alt="ces-logo" />
            <div className="divider"></div>
            <div>
              <span className="event-info event-info-bold">
                2025, JAN 7 - 10
              </span>
              <p className="event-info event-info-light">
                Las Vegas Venetian Expo, Hall G(1F), Eureka Park
              </p>
              <p className="event-info event-info-light">
                Booth No. :{" "}
                <span className="event-info event-info-bold">62817-25</span> /
                <br />
                <span className="event-booth-place">
                  Seoul Metropolitan Government
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="maintainers">
        <Maintainer
          position="CEO"
          name="Seok Jeong-Ho"
          descriptions={[
            "Psychiatrist, Gangnam Severance Hospital",
            "Professor of Psychiatry",
            "Depression specialist",
          ]}
        ></Maintainer>
        <Maintainer
          position="Research Director"
          name="Jang Sooah"
          descriptions={[
            "Psychiatrist",
            "Adjunct Professor, Yonsei University College of Medicine",
            "Doctor of Medicine, Yonsei University College of Medicine",
          ]}
        ></Maintainer>
        <Maintainer
          position="Senior Researcher"
          name="Shin HyunKyung"
          descriptions={[
            "Senior researcher, MINDSAI",
            "Clinical psychologist, Cheeu Counseling Center",
          ]}
        ></Maintainer>
      </div>
    </div>
  );
};

const Maintainer = ({ position, name, descriptions }) => {
  return (
    <div className="maintainer" style={{ padding: "20px" }}>
      <p className="maintainer-position">{position}</p>
      <p className="maintainer-name">{name}</p>
      <div className="maintainer-descriptions">
        {descriptions.map((description, index) => (
          <p key={index} className="maintainer-description">
            {description}
          </p>
        ))}
      </div>
    </div>
  );
};

export default EventDetails;
